<template>
    <text-element
        idKey="password"
        :type="showPassword ? 'text' : 'password'"
        required
        autocomplete="current-password"
        v-model="password"
        placeholder="Password"
        @keyup.enter="enterHandler"
        :errors="errors || null"
    >
        <label
            for="password"
            class="text-sm font-medium won-label-text-color mb-2 block"
            v-if="showLabel"
        >
            Password
        </label>

        <template #inputIcon>
            <ShowPasswordTrigger
                @trigger-show="showPasswordTriggerHandler"
                :isOpen="showPassword"
            />
        </template>
    </text-element>
</template>

<script setup>
import { ref } from 'vue';
import ShowPasswordTrigger from "../utils/show-password-trigger.vue";
import TextElement from "../../forms/elements/text.vue";

const emit = defineEmits(["keyup:enter"]);
const props = defineProps({
    errors: {
        type: String,
        default: null
    },
    showLabel: {
        type: Boolean,
        default: true
    }
})

const password = defineModel()

const showPassword = ref(false)

const showPasswordTriggerHandler = () => {
    showPassword.value = !showPassword.value;
}

const enterHandler = (event) => {
    emit('keyup:enter', event);
} 
</script>

